import PropTypes from "prop-types";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@material-ui/core";

// Dialog de confirmacion al intentar salir con cambios sin guardar. Compartido
// por la creacion y la edicion de propuestas V2.
const DialogDescartarCambios = ({ open, onSeguir, onDescartar }) => (
  <Dialog open={open} onClose={onSeguir} maxWidth="xs" fullWidth>
    <DialogTitle>¿Descartar los cambios?</DialogTitle>
    <DialogContent>
      <Typography variant="body2">
        Tienes cambios sin guardar que se perderán si sales de la vista.
      </Typography>
    </DialogContent>
    <DialogActions sx={{ px: 3, py: 2 }}>
      <Button onClick={onSeguir} color="inherit">
        Seguir editando
      </Button>
      <Button onClick={onDescartar} color="error" variant="contained">
        Descartar y salir
      </Button>
    </DialogActions>
  </Dialog>
);

DialogDescartarCambios.propTypes = {
  open: PropTypes.bool,
  onSeguir: PropTypes.func.isRequired,
  onDescartar: PropTypes.func.isRequired,
};

export default DialogDescartarCambios;
